import { BaseSearch } from "./BaseSearch";
import { BaseComponentProps } from "../types";

export type SearchArgs = {
  searchText: string;
};

type SearchProps = BaseComponentProps<"input"> & {
  placeholder?: string;
  /** Time for debounce delay. Default is 1000ms */
  debounceTime?: number;
  /** for controlled input */
  value?: string;
  /** Function called when the user hits the "Enter" key in the search input. */
  onSearch: ({ searchText }: SearchArgs) => void;
  /** Boolean to turn on/off search as you type. */
  incrementalSearch?: boolean;
  /* Optional and specific enter key press handler */
  onKeyEnter?<P extends unknown[]>(args?: P): void;
};

export const Search = ({
  placeholder = "Search",
  onSearch,
  incrementalSearch = false,
  value = "",
  onKeyEnter,
  ...inputProps
}: SearchProps) => {
  return (
    <BaseSearch
      placeholder={placeholder}
      onSearch={({ searchText }) => onSearch({ searchText })}
      incrementalSearch={incrementalSearch}
      value={value}
      scopes={[]}
      onKeyEnter={onKeyEnter}
      {...inputProps}
    />
  );
};
